import { render, staticRenderFns } from "./SmOwRadioSelectsQuestion.vue?vue&type=template&id=20e67d38&"
import script from "./SmOwRadioSelectsQuestion.vue?vue&type=script&lang=ts&"
export * from "./SmOwRadioSelectsQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports